import { create } from 'zustand';
import { waitForIDs } from 'app/copied/getIds';

interface WebchatStore {
  webchatVersion: string | null;
  fetchWebchatVersion: () => Promise<void>;
  isLoading: boolean;
}

export const useWebchatStore = create<WebchatStore>((set) => ({
  webchatVersion: null,
  isLoading: true,
  fetchWebchatVersion: async () => {
    try {
      const result = await waitForIDs();
      if (result && result.webchatVersion) {
        set({ webchatVersion: result.webchatVersion, isLoading: false });
      } else {
        set({ webchatVersion: null, isLoading: false });
      }
    } catch (error) {
      set({ webchatVersion: null, isLoading: false });
      throw error;
    }
  },
}));

useWebchatStore.getState().fetchWebchatVersion();
